module.exports = __webpack_public_path__ + "static/media/Apercu.8bdb4d16.woff";